<template>
  <div class="wrapper">
    <Insure @refresh="$emit('refresh')" @close="close" :id="data.id" method="post" type="bundles" :bundleType="data.bundleType" v-if="change" :checked="checked" />
    <div class="header">
      <div class="flexing">
        <div :class="[lang === 'ar' ? 'bold-ar': 'bold-en', 'titles']">{{ data.title }}</div>
        <label class="switch">
          <input @click="activation" v-model="checked" type="checkbox">
          <span class="slider"></span>
          <div :style="{transform : checked ? 'translateX(1.2em)' : 'translateX(0em)'}" id="border" class="slider-border"></div>
        </label>
      </div>
      <div class="mini-title">
        <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">
          <span v-if="data.miniTitle !== 0">{{ data.miniTitle }} {{ $t('Bundles.sp')}}</span>
          <span v-else>{{$t('free')}}</span>
        </span>
        <span v-if="data.miniTitle !== 0" :class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">
          <span>/</span>
          <span> {{ data.type === 0 ?  $t('Bundles.day') : data.type === 1 ?  $t('Bundles.week') :  $t('Bundles.month') }}</span>
        </span>
      </div>
    </div>
    <div :class="[lang === 'ar' ? 'regular-ar' : 'regular-en', 'description']">
      {{ data.desc }}
    </div>
    <div class="date">
      <div>
        <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.startDate')}}</span>
        <span>{{ data.startDate.slice(0, 10) }}</span>
      </div>
      <div>
        <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ $t('profile.endDate')}}</span>
        <span>{{ data.endDate.slice(0, 10) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import Insure from '../../components/dialogs/Insure'
export default {
  components: { Insure },
  props: {
    data: Object
  },
  data () {
    return {
      lang: this.$lang,
      change: false,
      checked: this.data.checked
    }
  },
  watch: {
    checked (val) {
    }
  },
  created () {
  },
  methods: {
    close () {
      this.change = false
      this.checked = !this.checked
    },
    activation () {
      this.change = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
/*--- switch button ----*/
/* The switch - the box around the slider */
.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 2.8em;
  height: 1.5em;
  border-radius: 50px;
  box-shadow: 10px 10px 20px rgba(0,0,0,0.08)
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  border: 2px solid $--yellow;
  border-radius: 50px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.slider:before {
  position: absolute;
  content: "";
  height: 1em;
  width: 1em;
  left: 0.2em;
  bottom: 0.14em;
  background-color: $--yellow;
  border-radius: inherit;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
}
.slider-border {
  height: 1em;
  width: 1em;
  border: .8px solid #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 0.32em;
  bottom: 0.25em;
  filter: blur(1px);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  cursor: pointer;
}

.switch input:checked + .slider:before {
  transform: translateX(1.2em);
}
/*---------------------------------*/
.wrapper {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.flexing {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titles {
  color: $--yellow;
  font-size: 22px
}
.mini-title > span:first-child {
  font-size: 18px
}
.mini-title > span:last-child {
  font-size: 13px
}
.description {
  width: 60%;
  font-size: 14px;
  padding: 1.5rem  0;
  word-break: break-all;
}
.date{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.date > div > span:first-child {
  color: $--yellow;
  font-size: 17px
}
/*---------- responsive ----------*/
@media (max-width: 700px) {
  .description{
    width: 100%
  }
  .date {
    display: block;
  }
}
@media (max-width: 480px) {
  .description{
    padding: 1rem 0
  }
  .titles {
    font-size: 20px;
  }
  .flexing {
    display: block;
  }
}
/*--------------------------------*/
</style>
